import SvgToIcon from "../../icons/SvgToIcon";
import AIDashboard from "../../scenes/dashboard/ai_posture/AIDashboard";
import Dashboard from "../../scenes/dashboard/Dashboard";
import InternalDashboard from "../../scenes/dev/InternalDashboard/InternalDashboard";
import UserAccessReview from "../../scenes/permissions/UserAccessReview/UserAccessReview";
import AdminPermissionsView from "../../scenes/permissions/UserPermissionsReview/AdminPermissionsView";
import ControlsView from "../../scenes/posture/controls/ControlsView";
import FrameworksView from "../../scenes/posture/frameworks/FrameworksView";
import ScenariosView from "../../scenes/posture/scenarios/ScenariosView";
import VulnerabilitiesView from "../../scenes/posture/vulnerabilities/VulnerabilitiesView";
import RemediationPlanView from "../../scenes/remediation/plan/RemediationPlanView";
import TrackingView from "../../scenes/remediation/tracking/TrackingView";
import WorkflowsView from "../../scenes/remediation/workflows/WorkflowsView";
import SettingsView from "../../scenes/settings/SettingsView";
import AssetsView from "../../scenes/stack/assets/AssetsView";
import EnvironmentView from "../../scenes/stack/environment/EnvironmentView";
import {
  icons,
  sidebarIcons,
} from "../../scenes/stack/environment/icons/iconExport";
import Integrations from "../../scenes/stack/integrations";
import TenantsManagementView from "../../scenes/tenants_management/TenantsManagementView";

export default function getAppScenes(
  viewAllPagesPermitted = true,
  aiPostureDashboardEnabled = false
) {
  return [
    {
      name: "Dashboard",
      path: "/",
      element: <Dashboard />,
      pages: [
        {
          title: "Overview",
          path: "/",
          icon: <SvgToIcon IconLogo={sidebarIcons.DashboardIcon} />,
          element: <Dashboard />,
          enabled: true,
          notPermitted: !viewAllPagesPermitted,
        },
        {
          title: "AI Posture",
          path: "/ai-posture",
          icon: <SvgToIcon IconLogo={sidebarIcons.AIIcon} />,
          element: <AIDashboard />,
          enabled: aiPostureDashboardEnabled || false,
          notPermitted: !viewAllPagesPermitted,
        },
        {
          title: "Frameworks",
          path: "/frameworks",
          icon: <SvgToIcon IconLogo={sidebarIcons.FrameworkIcon} />,
          element: <FrameworksView />,
          enabled: true,
          notPermitted: !viewAllPagesPermitted,
        },
      ],
      notPermitted: !viewAllPagesPermitted,
    },

    {
      name: "Risk",
      path: "/posture",
      pages: [
        {
          title: "Controls",
          path: "/posture/controls",
          icon: <SvgToIcon IconLogo={sidebarIcons.ControlsIcon} />,
          element: <ControlsView />,
          enabled: true,
          notPermitted: false,
        },

        {
          title: "Attack Surface",
          path: "/posture/surface",
          icon: <SvgToIcon IconLogo={sidebarIcons.ScenariosIcon} />,
          element: <ScenariosView />,
          enabled: true,
          notPermitted: !viewAllPagesPermitted,
        },
        {
          title: "Vulnerabilities",
          path: "/posture/vulnerabilities",
          icon: <SvgToIcon IconLogo={sidebarIcons.VulnerabilitiesIcon} />,
          element: <VulnerabilitiesView />,
          enabled: true,
          notPermitted: !viewAllPagesPermitted,
        },
      ],
    },
    {
      name: "Remediation",
      path: "/remediation",
      pages: [
        {
          title: "Remediation",
          path: "/remediation/plan",
          icon: <SvgToIcon IconLogo={sidebarIcons.RemediationPlanIcon} />,
          element: <RemediationPlanView />,
          enabled: true,
          notPermitted: false,
        },
        {
          title: "Workflows",
          path: "/remediation/workflows",
          icon: <SvgToIcon IconLogo={sidebarIcons.WorkflowsIcon} />,
          element: <WorkflowsView />,
          enabled: true,
          notPermitted: false,
        },
        {
          title: "Tracking",
          path: "/remediation/tracking",
          icon: <SvgToIcon IconLogo={sidebarIcons.TrackingIcon} />,
          element: <TrackingView />,
          enabled: true,
          notPermitted: !viewAllPagesPermitted,
        },
      ],
    },
    {
      name: "Assets",
      path: "/inventory",
      pages: [
        {
          title: "Critical Assets",
          path: "/inventory/assets",
          icon: <SvgToIcon IconLogo={sidebarIcons.AssetsIcon} />,
          element: <AssetsView />,
          enabled: true,
          notPermitted: !viewAllPagesPermitted,
        },
        {
          title: "Inventory",
          path: "/inventory/environment",
          icon: <SvgToIcon IconLogo={sidebarIcons.EnvironmentIcon} />,
          element: <EnvironmentView />,
          enabled: true,
          notPermitted: false,
        },
      ],
    },
    {
      name: "Entitlements",
      path: "/entitlements",
      pages: [
        {
          title: "Permissions",
          path: "/entitlements/admins",
          icon: <SvgToIcon IconLogo={sidebarIcons.AdminPermissionsIcon} />,
          element: <AdminPermissionsView />,
          enabled: true,
          notPermitted: !viewAllPagesPermitted,
        },
        {
          title: "Access Review",
          path: "/entitlements/user-access-review",
          icon: <SvgToIcon IconLogo={sidebarIcons.UserAccessIcon} />,
          element: <UserAccessReview />,
          enabled: true,
          notPermitted: !viewAllPagesPermitted,
        },
      ],
    },
    {
      name: "Integrations",
      path: "/inventory",
      pages: [
        {
          title: "Integrations",
          path: "/inventory/integrations",
          icon: <SvgToIcon IconLogo={sidebarIcons.IntegrationsIcon} />,
          element: <Integrations />,
          enabled: true,
        },
      ],
      notPermitted: false,
    },
    {
      name: "Account",
      path: `/settings`,
      icon: <SvgToIcon IconLogo={sidebarIcons.AccountCenterIcon} />,
      element: <SettingsView />,
      enabled: true,
      notPermitted: false,
    },
    {
      name: "Account",
      path: `/tenants-management`,
      icon: <SvgToIcon IconLogo={icons.MultiTenantIcon} />,
      element: <TenantsManagementView />,
      enabled: true,
      notPermitted: !viewAllPagesPermitted,
    },
    {
      name: "Dev",
      path: "/dev",
      pages: [
        {
          title: "Internal",
          path: "/dev/internal-dashboard",
          icon: <SvgToIcon IconLogo={sidebarIcons.DashboardIcon} />,
          element: <InternalDashboard />,
          enabled: true,
        },
      ],
    },
  ];
}
